// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import * as RouteUtils from 'routes/route_utils.jsx';

export default {
    path: 'mfa',
    getComponents: (location, callback) => {
        import('components/mfa/mfa_controller.jsx').then(RouteUtils.importComponentSuccess(callback));
    },
    getChildRoutes: RouteUtils.createGetChildComponentsFunction(
        [
            {
                path: 'setup',
                getComponents: (location, callback) => {
                    import('components/mfa/components/setup.jsx').then(RouteUtils.importComponentSuccess(callback));
                }
            },
            {
                path: 'confirm',
                getComponents: (location, callback) => {
                    import('components/mfa/components/confirm.jsx').then(RouteUtils.importComponentSuccess(callback));
                }
            }
        ]
    )
};



// WEBPACK FOOTER //
// ./routes/route_mfa.jsx